import MainLayout from '@/common/components/layouts/MainLayout.tsx';
import LoadingPage from '@/common/pages/LoadingPage.tsx';
import IncidentDetailMainDetailCard from '@/modules/adjusterReportModules/IncidentDetails/components/incidentDetails/incidentDetailMainDetailCard';
import useIncidentDetailsBody from '@/modules/adjusterReportModules/IncidentDetails/pages/accidentDetailsBody/accidentDetailsBody.biz';
import { FormProvider, useForm } from 'react-hook-form';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';

const AccidentDetailsShowBody = () => {
  const methods = useForm();
  return (
    <MainLayout header="titleHeader" title="مشخصات حادثه" hasBottomPadding>
      <FormProvider {...methods}>
        <AccidentDetailsShowBodyPage />
      </FormProvider>
    </MainLayout>
  );
};
export default AccidentDetailsShowBody;

const AccidentDetailsShowBodyPage = () => {
  const { cardData, cardDataPending } = useIncidentDetailsBody();
  if (cardDataPending) {
    return <LoadingPage />;
  }
  return (
    <Box pt={25}>
      <IncidentDetailMainDetailCard
        fileNumber={cardData?.order_id!}
        fileType={cardData?.file_type.const!}
        svgColor={'colors.orange'}
        items={cardData?.detailCardItems ?? []}
        hasBullet={true}
        backgroundColor="orange-2"
        headerClassName={css({ borderColor: 'orange-2' })}
      />
    </Box>
  );
};
